import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBE: CultureInfo = {
  name: 'en-BE',
  displayName: 'English (Belgium)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BE',
  parent: CultureInfoEn
};
